import type { AutosaveStatus } from '../hooks/useAutosaveText'

export default function AutosaveStatusLabel({ status }: { status: AutosaveStatus }) {
  if (status === 'saving') return <span className="text-xs text-gray-500 dark:text-gray-400">Saving…</span>
  if (status === 'saved') return <span className="text-xs text-green-600 dark:text-green-400">✓ Saved</span>
  if (status === 'error') return <span className="text-xs text-red-600 dark:text-red-400">Save failed -- your text is kept, try again</span>
  return null
}
